import type { PeriodForMinutes } from './period-for-minutes';
import { LocalDate } from '../../../utilities/local-date';
import type { PeriodWithMinutes } from './period-with-minutes';
import { timeInMinutes } from './time-in-minutes';
import { sortBy } from 'lodash';
import type { SubPeriodWithMinutes } from './sub-period-with-minutes';
import { getSubPeriodsWithMinutes } from './get-sub-periods-with-minutes';

/**
 * Takes a list of periods and a date for year start
 * Returns a list of periods with start and end time in minutes from year start
 */
export function getPeriodsWithMinutes(periods: PeriodForMinutes[], yearStartDate: LocalDate): PeriodWithMinutes[] {
  const oPeriods = periods.map((period) => {
    const startDate = LocalDate.fromString(period.start);
    let startMinutes = yearStartDate.until(startDate) * 1440;
    if (period.startTime) {
      startMinutes += timeInMinutes(period.startTime);
    }
    const endDate = LocalDate.fromString(period.end);
    let endMinutes = yearStartDate.until(endDate) * 1440;
    if (period.endTime) {
      endMinutes += timeInMinutes(period.endTime);
    } else {
      endMinutes += 1440;
    }
    let subPeriods: SubPeriodWithMinutes[] = [];
    if ('subPeriods' in period && period.subPeriods && period.subPeriods.length) {
      subPeriods = getSubPeriodsWithMinutes(period.subPeriods, yearStartDate);
    }
    return {
      start: period.start,
      end: period.end,
      startMinutes: startMinutes,
      endMinutes: endMinutes,
      type: 'type' in period ? (period.type ?? '') : 'plusTime',
      grade: 'grade' in period ? period.grade || 100 : 100,
      confirmed: period.confirmed,
      notes: period.notes,
      id: period.uuid,
      subPeriods: subPeriods,
    };
  });
  return sortBy(oPeriods, [(e) => e.startMinutes]);
}
